/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface BankDataModel {

        "bank"?: number;

        "agency"?: number;

        "account"?: number;
    }

}
